// Import AOS for animation
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();


const filtersList = document.querySelectorAll('.filter--toggle');

function filtersActive(e) {
  if (filtersList) {
    filtersList.forEach(filter => {
      if(filter === e.target) {
        filter.classList.add('filter--active');
      } else {
        filter.classList.remove('filter--active');
        filter.ariaExpanded = 'false';
      }
    })
  }
}
filtersList.forEach(filter => { filter.addEventListener('click', filtersActive) })

// Close the active dropdown when clicking outside
  window.addEventListener('click', (e) => {
    if (!e.target.matches('.filter--toggle')) {
      filtersList.forEach(filter => {
        filter.classList.remove('filter--active');
        filter.ariaExpanded = 'false';
      })
    }
});

const navLinkOpen = document.querySelectorAll('.x-menu--level-1--link');
const headerSimone = document.querySelector('.header--root');
const headerFixedSimone = document.querySelector('.header--fill-for-fixing');
const headerRight = document.querySelector('.header--right-column');
const headerLogo = document.querySelector('.header--logo');
const menuSimone = document.querySelector('.x-menu--level-2--container');

function navLinkOverActive(e) {
    navLinkOpen.forEach(link => {
      if(link === e.target) {
        headerSimone.classList.add('link--active');
      }
    })
}

function navLinkOverInactive(e) {
  navLinkOpen.forEach(link => {
    if(link === e.target) {
      headerSimone.classList.remove('link--active');
    }
  })
}

function headerActive() {
  headerSimone.classList.add('header--active');
}

function headerInactive() {
  headerSimone.classList.remove('header--active');
}

menuSimone.addEventListener('mouseover', headerActive);

menuSimone.addEventListener('mouseleave', headerInactive);

headerSimone.addEventListener('mouseover', headerActive)

headerSimone.addEventListener('mouseleave', headerInactive)

headerFixedSimone.addEventListener('mouseover', headerActive)

headerFixedSimone.addEventListener('mouseleave', headerInactive)

headerRight.addEventListener('mouseover', headerActive)

headerRight.addEventListener('mouseleave', headerInactive)

headerLogo.addEventListener('mouseover', headerActive)

headerLogo.addEventListener('mouseleave', headerInactive)

navLinkOpen.forEach(link => { link.addEventListener('mouseover', navLinkOverActive)});
navLinkOpen.forEach(link => { link.addEventListener('mouseleave', navLinkOverInactive)});

const hash = window.location.hash.substring(1); // Extract the hash from the path
const scrollElement = document.getElementById(hash);
if (scrollElement) {
  setTimeout(()=>{            //(1)
    const { top } = scrollElement.getBoundingClientRect();
    setTimeout(() => {   //(2)
      window.scrollTo({
        behavior: 'smooth',
        top: top + (window.scrollY || document.documentElement.scrollTop) - 100,
      });
    }, 300); //(2) Add delay for scrolling
  }, 300); //(1) Add delay for obtaining getBoundingClientRect
}
